const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
	url: '/app/api/cart/zip',
	api: 'local'
});
